import { getJson } from 'api/baseApi'

export const getLoginSettings = function () {
  return getJson({ url: '/api/server/settings/login' })
}

export const getCommentSettings = function () {
  return getJson({ url: '/api/server/settings/comment' })
}

export const getDatabaseVersionOk = function () {
  return getJson({ url: '/api/server/settings/dbversionok' })
}

export const getStampSettings = function () {
  return getJson({ url: '/api/server/settings/stamp' })
}

export const getPasswordSettings = function () {
  return getJson({ url: '/api/server/settings/password' })
}

export const getPasswordResetSettings = function () {
  return getJson({ url: '/api/server/settings/passwordreset' })
}

export const getClientPath = function () {
  return getJson({ url: '/api/server/settings/clientpath' })
}

export const getLoginOptions = function () {
  return getJson({ url: '/api/server/settings/loginoptions' })
}

export const getTitle = function () {
  return getJson({ url: '/api/server/settings/title' })
}

export const getMetadataLogSettings = function () {
  return getJson({ url: '/api/server/settings/metadatalog' })
}

export const getShareSelectionSettings = function () {
  return getJson({ url: '/api/server/settings/shareselection' })
}

export const getRightsSettings = function () {
  return getJson({ url: '/api/server/settings/rights' })
}

export const getCustomerDataSettings = function (value) {
  return getJson({url: '/api/server/customerdata/getsetting/' + value})
}

export const getCustomerDataSettingsList = function (value) {
  return getJson({url: '/api/server/customerdata/getsettings' + value})
}

export const getAlternativeTextSettings = function () {
  return getJson({ url: '/api/server/settings/alternativetext' })
}

export const getUserLanguage = function () {
  return getJson({ url: '/api/server/settings/getuserlanguage' })
}

export const getDocstreamSettings = function () {
  return getJson({ url: '/api/server/settings/docstreamsettings' })
}



// WEBPACK FOOTER //
// ./src/api/settingsApi.js